import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { DealResponse } from '../models/deal.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface DealDrawerOptions {
  dealId?: number;
  contactId?: number;
  companyId?: number;
  companyName?: string;
  contactName?: string;
  leadId?: number;
  leadName?: string;
}

@Injectable({ providedIn: 'root' })
export class DealDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: DealDrawerOptions }>({
    isOpen: false,
    options: {}
  });

  private readonly dealSaved$$ = new Subject<DealResponse>();

  readonly state = this.state$.asObservable();
  /** Emits the saved deal whenever one is created or updated via the drawer */
  readonly dealSaved$ = this.dealSaved$$.asObservable();

  open(options: DealDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }

  notifySaved(deal: DealResponse): void {
    this.dealSaved$$.next(deal);
  }
}
